import React from "react";
import "./index.scss";

function Media({ children }) {
  return <div className="Media">{children}</div>;
}

export default Media;
